import { render, staticRenderFns } from "./ConstituentsList.vue?vue&type=template&id=8ebef204&"
import script from "./ConstituentsList.vue?vue&type=script&lang=js&"
export * from "./ConstituentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports